import { Routes, Route, Link } from 'react-router-dom'

import ScrollToTop from '@/components/ScrollToTop/ScrollToTop'
import AppFooter from '@/components/Footer/AppFooter'
import Aside from '@/layouts/Aside/Aside'
import HomePage from '@/pages/HomePage/HomePage'
import ArticlePage from '@/pages/ArticlePage/ArticlePage'

import perspektywyLogo from '@/assets/img/perspektywy_logo.png'

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="App">
        <div className="AppContent container">
          <header className="homePage__header d-flex justify-content-between flex-column flex-md-row text-center px-3 py-4">
            <a
              href="https://perspektywy.pl"
              target="_blank"
              rel="noopener noreferrer"
              className="mb-3 mb-md-0"
            >
              <img src={perspektywyLogo} alt="Perspektywy" />
            </a>
            <Link to="/" className="ml-0 ml-md-3">
              <h1>
                Wybory <span className="font-weight-bold">Rektorów 2024</span>
              </h1>
            </Link>
          </header>
          <hr />
          <div className="row">
            <div className="col-lg-9">
              <main>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/article/:slug" element={<ArticlePage />} />
                </Routes>
              </main>
            </div>
            <div className="col-lg-3">
              <Aside />
            </div>
          </div>
        </div>
        <AppFooter />
      </div>
    </>
  )
}